module.exports = __webpack_public_path__ + "static/media/tower_logo_white.6bbf4da2.png";